import React, { Component } from "react";

import "./App.css";
import Secured from "./components/Secured";
import { connect } from "react-redux";
import { ErrorPage } from "./components/extensions";
import { locked } from "./images";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltCircleLeft } from "@fortawesome/free-solid-svg-icons";

class App extends Component {
  state = {
    isAllowed: false,
  };
  allowedRoles = () => {
    return ["pawnshop-reports-user"];
  };

  componentDidMount() {
    if (!this.props.tokenDetail.realm_access) {
      this.setState({ isAllowed: false });
    } else {
      var roles = this.props.tokenDetail.realm_access.roles;
      this.setState({ isAllowed: this.validateRoles(roles) });
    }
  }

  validateRoles = (roles) => {
    if (roles) {
      if (roles.length > 0) {
        let items = 0;
        roles.forEach((r) => {
          var data = this.allowedRoles().filter((alr) => alr === r);
          if (data) {
            items++;
          }
        });

        return items > 0;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  renderNotAllowed = () => {
    return (
      <div>
        <ErrorPage
          title="Access Denied"
          img={locked}
          description="It seems like you don't have permission to access this page. 
        You may contact admininstrator for support."
          options={
            <span>
              <Button
                onClick={() => {
                  this.props.keycloak.logout();
                }}
                size="sm"
                variant="link"
                className="strong"
              >
                <FontAwesomeIcon icon={faArrowAltCircleLeft} /> Go back to Login
              </Button>
            </span>
          }
        />
      </div>
    );
  };

  render() {
    return this.state.isAllowed ? <Secured /> : this.renderNotAllowed();
  }
}

const mapStateToProps = (state) => {
  return {
    tokenDetail: state.keycloak.tokenDetails,
    keycloak: state.keycloak.keycloak,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(App);
